import { defineComponent } from "vue";
import Popup from "../../share/popup";

import "./health.less";

export default defineComponent({
  emits: ["confirm"],
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const onConfirmClick = () => {
      emit("confirm");
    };

    return () => (
      <Popup closeOnOverlayClick={false} position="center" visible={props.visible} width={320}>
        <div class="feiyu-pay-health">
          <div class="feiyu-pay-health--title">{"健康提示"}</div>
          <div class="feiyu-pay-health--content">{props.message}</div>
          <div class="feiyu-pay-health--button" onClick={onConfirmClick}>
            {"我知道了"}
          </div>
        </div>
      </Popup>
    );
  },
});
